/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        const LOG_CATEGORY = "WPT.Widgets.RecentDocuments";
        class RecentDocumentsWidgetTypeClass extends Widgets.WidgetTypeBaseClass {
            constructor(core, widgets, widgetName, config, layout, readyCallback = null) {
                super(core, widgets, widgetName, config, layout, readyCallback);
                this.createInstance = (config) => {
                    this._log.info("RecentDocumentsWidgetTypeClass.createInstance()");
                    return new RecentDocumentsWidgetInstanceClass(this._core, this, this._widgets, config, this._originatingLayout);
                };
                this._storeHtml = (htmlData) => {
                    this._log.info("RecentDocumentsWidgetTypeClass._storeHtml()");
                    RecentDocumentsWidgetInstanceClass.HtmlData = htmlData;
                    this._presentInstances();
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("RecentDocumentsWidgetTypeClass::constructor");
                if (RecentDocumentsWidgetInstanceClass.HtmlData != null) {
                    window.setTimeout(this._presentInstances, 0);
                }
                else {
                    core.Loader.getVersionedHTML('widgets/RecentDocuments/recent-documents.html', this._storeHtml, this._core.Helper.missingHtmlErrorCallback);
                }
            }
        }
        Widgets.RecentDocumentsWidgetTypeClass = RecentDocumentsWidgetTypeClass;
        class RecentDocumentsWidgetInstanceClass extends Widgets.WidgetInstanceBaseClass {
            constructor(core, type, widgets, config, layout) {
                super(core, type, widgets, config, layout);
                this._instanceSelector = null;
                this._componentContainer = null;
                this._activateAsPrimary = true;
                this._activateAsRelated = false;
                this._activateIntoSlot = null;
                this._refreshTriggers = null;
                this._refreshButton = null;
                this._riComponent = null;
                this.presentInstance = () => {
                    this._log.info("RecentDocumentsWidgetInstanceClass.presentInstance()");
                    this._container.innerHTML = RecentDocumentsWidgetInstanceClass.HtmlData;
                    this._prepareErrorBanner();
                    this._componentContainer = this._container.querySelector('#recentDocsComponentContainer');
                    this._refreshButton = this._container.querySelector('#recentDocumentsReload');
                    this._widgets.setTitle(this._config, this._container.querySelector('#recentDocumentsWidgetHeadingText'), 'STR_WPT_RECENT_DOCUMENTS');
                    this._widgets.setCollapseState(this._config, this._instanceSelector);
                    this._widgets.addCollapseEventListener(this);
                    this._widgets.setWidgetHeight(this._config, this._container);
                    this._widgets.setSuppressBorder(this._config, this._container);
                    this._widgets.setSuppressHeading(this._config, this._container);
                    this._refreshButton.addEventListener('click', this._refresh);
                    this._core.Helper.setElementTranslationAttribute(this._refreshButton, 'title', 'STR_WPT_REFRESH');
                    let componentConf = {};
                    this._riComponent = new Widgets.ComponentRecentDocuments(this._core, this._componentContainer, this, componentConf);
                    this._riComponent.ErrorCallback = this._callErrorHandler;
                    this._riComponent.FailCallback = this._callFailedHandler;
                    this._riComponent.DocumentSelectedCallBack = this._docClicked;
                    this._riComponent.present();
                    this._refresh();
                    this._type.instanceReady(this.getHandle());
                };
                this._callFailedHandler = (json) => {
                    this._log.info("RecentDocumentsWidgetInstanceClass._callFailedHandler()");
                    let response = json;
                    this.addError(response.Connection.Message);
                };
                this._callErrorHandler = (url, status, message) => {
                    this._log.info("RecentDocumentsWidgetInstanceClass._callErrorHandler()");
                    this.addError(message);
                };
                this._refresh = () => {
                    this._log.info("RecentDocumentsWidgetInstanceClass._refresh()");
                    this._riComponent.refresh();
                };
                this._docClicked = (doc) => {
                    this._log.info("RecentDocumentsWidgetInstanceClass._docClicked()");
                    let config = this._config;
                    let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.DOCUMENT_SELECTED);
                    navEvent.ActivationID = doc.ItemNum;
                    navEvent.PrimaryContext = doc;
                    if (this._activateAsPrimary)
                        navEvent.Slots.push(WPTNamespace.Utilities.PRIMARY_SLOT_KEY);
                    if (this._activateAsRelated)
                        navEvent.Slots.push(WPTNamespace.Utilities.RELATED_SLOT_KEY);
                    if (this._activateIntoSlot)
                        navEvent.Slots.push(this._activateIntoSlot);
                    // Set default layout, but check if we've had an alternative requested against the instance
                    let targetLayoutName = "PersonalDocuments";
                    if (config.hasOwnProperty("LaunchLayout") && config.LaunchLayout) {
                        if (config.LaunchLayout == "[[CURRENT]]")
                            targetLayoutName = this._currentLayout;
                        else
                            targetLayoutName = config.LaunchLayout;
                    }
                    // Add transfer widgets if we are moving
                    if (targetLayoutName != this._currentLayout) {
                        if (config.hasOwnProperty("ForwardOtherWidgets")) {
                            navEvent.populateTransferList(config.ForwardOtherWidgets, this._core);
                        }
                    }
                    navEvent.Layout = targetLayoutName;
                    this._core.Navigation.Details.requestActivation(navEvent);
                };
                this.returnedToHomepage = () => {
                    this._log.info("RecentDocumentsWidgetInstanceClass.returnedToHomepage()");
                    super.returnedToHomepage();
                    this._widgets.setCollapseState(this._config, this._instanceSelector);
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("RecentDocumentsWidgetInstanceClass::constructor");
                this._instanceSelector = config.PlaceHolder;
                this._container = document.querySelector(this._instanceSelector);
                let conf = this._config;
                if (conf.hasOwnProperty("ActivateAsPrimary") && (conf.ActivateAsPrimary))
                    this._activateAsPrimary = true;
                if (conf.hasOwnProperty("ActivateAsRelated") && (conf.ActivateAsRelated))
                    this._activateAsRelated = true;
                if (conf.hasOwnProperty("ActivateIntoSlot") && (conf.ActivateIntoSlot != null))
                    this._activateIntoSlot = conf.ActivateIntoSlot;
                if (config.hasOwnProperty('RefreshTriggers') && conf.RefreshTriggers && (conf.RefreshTriggers.length > 0))
                    this._refreshTriggers = conf.RefreshTriggers;
                else
                    this._refreshTriggers = [];
                this._core.Functions.addDefaultsToTriggerEvents(this._refreshTriggers);
            }
            activate(context) {
                this._log.info("RecentDocumentsWidgetInstanceClass.activate()");
                // Don't get stuck in a loop!
                if (!this._activationSourceValid(context))
                    return;
                if (this._refreshTriggers.length > 0) {
                    // Loop with iterator so we can escape when necessary
                    for (let i = 0; i < this._refreshTriggers.length; i++) {
                        let trigger = this._refreshTriggers[i];
                        if (this._core.Functions.triggerEventMatches(trigger, context)) {
                            this._refresh();
                            // Only trigger once
                            return;
                        }
                        else {
                            continue;
                        }
                    }
                }
            }
        }
        RecentDocumentsWidgetInstanceClass.HtmlData = null;
        Widgets.RecentDocumentsWidgetInstanceClass = RecentDocumentsWidgetInstanceClass;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
